import { render, staticRenderFns } from "./PConfirm.vue?vue&type=template&id=6e0373da"
import script from "./PConfirm.vue?vue&type=script&lang=js"
export * from "./PConfirm.vue?vue&type=script&lang=js"
import style0 from "./PConfirm.vue?vue&type=style&index=0&id=6e0373da&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports